export const authPanelShellMaxWidth = 'sm' as const;
export const authPanelNarrowSx = { maxWidth: '25rem', mx: 'auto' } as const;
export const authPanelWideSx = { maxWidth: '28rem', mx: 'auto' } as const;
